"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ChangePasswordLogin = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _styles = require("./styles");

var _CarouselImagesLogin = require("../../molecules/CarouselImagesLogin");

var _LoginPasswordStrength = require("../../molecules/LoginPasswordStrength");

var _react = require("react");

var _GeneralButton = require("../../atoms/GeneralButton");

var _LogoImage = require("../../atoms/LogoImage");

var _ScreenHeader = require("../../atoms/ScreenHeader");

var _variables = require("../../../global-files/variables");

var _GradientPanel = require("../../atoms/GradientPanel");

var _jsxRuntime = require("react/jsx-runtime");

var ChangePasswordLogin = function ChangePasswordLogin(_ref) {
  var _ref$imageArrayCarous = _ref.imageArrayCarousel,
      imageArrayCarousel = _ref$imageArrayCarous === void 0 ? [] : _ref$imageArrayCarous,
      textCarousel = _ref.textCarousel,
      backogroundColorCarousel = _ref.backogroundColorCarousel,
      textHeaderRight = _ref.textHeaderRight;

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      emptyPassword = _useState2[0],
      setEmptyPassword = _useState2[1];

  var _useState3 = (0, _react.useState)(false),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      emptyConfirmPassword = _useState4[0],
      setEmptyConfirmPassword = _useState4[1];

  var _useState5 = (0, _react.useState)(true),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      matchPasswords = _useState6[0],
      setMatchPasswords = _useState6[1];

  var validate = function validate(e) {
    var password = document.querySelector("#newPasswordInput").value;
    password.length < 8 ? setEmptyPassword(true) : setEmptyPassword(false);
    var confirmPassword = document.querySelector("#confirmPasswordInput").value;
    confirmPassword === "" ? setEmptyConfirmPassword(true) : setEmptyConfirmPassword(false);

    if (password === confirmPassword) {
      setMatchPasswords(true);
    } else {
      setMatchPasswords(false);
    }
  };

  var loginRight = [/*#__PURE__*/(0, _jsxRuntime.jsx)(_LogoImage.LogoImage, {}, "1"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "credenciales",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_ScreenHeader.ScreenHeader, {
      fontFamily: _variables.FontFamily.AvenirNext,
      color: _variables.GlobalColors.s5,
      text: textHeaderRight
    })
  }, "2"), /*#__PURE__*/(0, _jsxRuntime.jsx)(_LoginPasswordStrength.LoginPasswordStrength, {
    emptyPassword: emptyPassword,
    emptyConfirmPassword: emptyConfirmPassword,
    matchPasswords: matchPasswords,
    textTittle: textHeaderRight
  }, "3"), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: "button-center",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GeneralButton.Button, {
      buttonType: "general-default-button",
      label: "Enviar",
      onClick: function onClick(e) {
        return validate(e);
      }
    })
  }, "4")];
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_styles.Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "home-retailer",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_CarouselImagesLogin.CarouselImagesLogin, {
        panelImg: imageArrayCarousel,
        panelText: textCarousel,
        panelColor: backogroundColorCarousel
      })
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
      className: "home-login-retailer",
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_GradientPanel.GradientPanel, {
        panelColor: _variables.GlobalColors.white,
        componentsArray: loginRight,
        panelType: "home-login"
      })
    })]
  });
};

exports.ChangePasswordLogin = ChangePasswordLogin;